import { amtReg, amtRegMessage } from './regConstants'


export const billReviewCols = [
    {
        title: '序号',
        dataIndex: '序号',
        editable: false,
    },
    {
        title: '开立票据名称',
        dataIndex: '开立票据名称',
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                ],
            };
        }
    },
    {
        title: '身份证号',
        dataIndex: '身份证号',
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^\w{0,18}$/, message: '不能超过18位' }
                ],
            };
        }
    },
    {
        title: '纳税人识别号',
        dataIndex: '纳税人识别号',
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^\w{18}$/, message: '固定18位,或不填' },
                ],
            };
        }
    },
    {
        title: '金额',
        dataIndex: '金额',
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                    { pattern: amtReg, message: amtRegMessage }
                ],
            };
        }
    },
    {
        title: '用途',
        dataIndex: '用途',
        valueType: 'select',
        // valueEnum: {
        //     '捐赠款-慈善': {
        //         text: '捐赠款-慈善',
        //     },
        //     '捐赠款-医疗': {
        //         text: '捐赠款-医疗',
        //     },
        //     '捐赠款-教育': {
        //         text: '捐赠款-教育',
        //     },
        //     '捐赠款-人文环保': {
        //         text: '捐赠款-人文环保',
        //     },
        // },
        width: '6rem',
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                ],
            };
        }
    },
    {
        title: '备注',
        dataIndex: '备注',
    },
    // @tmpdel
    // {
    //     title: '非陆籍填1',
    //     dataIndex: '非陆籍填1',
    //     valueType: 'select',
    //     valueEnum: {
    //         '1': {
    //             text: '1',
    //         },
    //         // 非陆籍
    //         '': {
    //             text: ' ',
    //         },
    //     },
    // },
    // {
    //     title: '法人填1，自然人不填',
    //     dataIndex: '法人填1，自然人不填',
    //     valueType: 'select',
    //     valueEnum: {
    //         '1': {
    //             text: '1',
    //         },
    //         '': {
    //             text: ' ',
    //         },
    //     },
    // },
    {
        title: '志工编号',
        dataIndex: '志工编号',
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                ],
            };
        }
    },
    {
        title: '志工姓名',
        dataIndex: '志工姓名',
    },
    {
        title: '志工英文名',
        ch_title: '志工英文名',
        en_title: 'Commissioner enName',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '手机号',
        dataIndex: '手机号',
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^1\d{10}$/, message: '1开头的11位数字,或不填' }
                ],
            };
        }
    },
    {
        title: '地址',
        dataIndex: '地址',
    },
    {
        title: '邮箱',
        dataIndex: '邮箱',
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, message: '须符合邮箱格式或不填' }
                ],
            };
        }
    },
];


export const proc_qry_billCols = [
    {
        title: '序号',
        dataIndex: '序号',
    },
    {
        title: '开立票据名称',
        dataIndex: '开立票据名称',
    },
    {
        title: '身份证号',
        dataIndex: '身份证号',
    },
    {
        title: '纳税人识别号',
        dataIndex: '纳税人识别号',
    },
    {
        title: '金额',
        dataIndex: '金额',
    },
    {
        title: '用途',
        dataIndex: '用途',
    },
    {
        title: '备注',
        dataIndex: '备注',
    },
    // @tmpmdel
    // {
    //     title: '非陆籍填1',
    //     dataIndex: '非陆籍填1',
    // },
    // {
    //     title: '法人填1，自然人不填',
    //     dataIndex: '法人填1，自然人不填',
    // },
    {
        title: '志工编号',
        dataIndex: '志工编号',
    },
    {
        title: '志工姓名',
        dataIndex: '志工姓名',
    },
    {
        title: '志工英文名',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '地址',
        dataIndex: '地址',
    },
    {
        title: '邮箱',
        dataIndex: '邮箱',
    },
];


export const proc_prev_billCols = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
        editable: false,
    },
    {
        title: '开立票据名称',
        ch_title: '开立票据名称',
        en_title: 'Receipt Title',
        dataIndex: '开立票据名称',
        render: (text, record) => {
            let valid = record.billNameValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='必填' trigger="hover">
                    <div style={execStyle}>
                        {text ? text : '-'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                ],
            };
        }
    },
    {
        title: '身份证号',
        ch_title: '身份证号',
        en_title: 'ID No.',
        dataIndex: '身份证号',
        render: (text, record) => {
            let valid = record.idcValid;
            // 校验：非必填，小于等于18位
            return !valid ? (
                <Tooltip title='不能超过18位' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '-'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^\w{0,18}$/, message: '不能超过18位' }
                ],
            };
        }
    },
    {
        title: '纳税人识别号',
        ch_title: '纳税人识别号',
        en_title: 'TIN',
        dataIndex: '纳税人识别号',
        render: (text, record) => {
            let valid = record.creditNoValid;
            // TODO 暂时不校验
            valid = true;
            // 校验：必填
            return !valid ? (
                <Tooltip title='固定18位,或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '-'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^\w{18}$/, message: '固定18位,或不填' },
                ],
            };
        }
    },
    {
        title: '金额',
        ch_title: '金额',
        en_title: 'Amount',
        dataIndex: '金额',
        render: (text, record, index) => {
            let valid = record.amtValid;
            // Tooltip
            return !valid ? (
                <Tooltip title={amtRegMessage} trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '-'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                    { pattern: amtReg, message: amtRegMessage }
                ],
            };
        }
    },
    {
        title: '用途',
        ch_title: '用途',
        en_title: 'Purpose',
        dataIndex: '用途',
        valueType: 'select',
        // valueEnum: {
        //     '捐赠款-慈善': {
        //         text: '捐赠款-慈善',
        //     },
        //     '捐赠款-医疗': {
        //         text: '捐赠款-医疗',
        //     },
        //     '捐赠款-教育': {
        //         text: '捐赠款-教育',
        //     },
        //     '捐赠款-人文环保': {
        //         text: '捐赠款-人文环保',
        //     },
        // },
        width: '6rem',
        render: (text, record) => {
            let purposeStr = record['用途'];
            let valid = record.purposeValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='必填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {(purposeStr == 'undefined' || !purposeStr) ? '-' : purposeStr}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '用途必填' },
                ],
            };
        }
    },
    {
        title: '备注',
        en_title: 'Remarks',
        ch_title: '备注',
        dataIndex: '备注',
        // //按备注排序 为空的排在后面
        // sorter: (a, b) => {
        //     // console.log('sorter:', a['备注'], b['备注']);
        //     if (a['备注'] != '' && b['备注'] == '') {
        //         return -1
        //     } else if (a['备注'] == '' && b['备注'] != '') {
        //         return 1
        //     } else {
        //         return 0
        //     }
        // },
        filters: [
            {
                text: '不为空的',
                value: 'not_empty',
            },
        ],
        filterMode: 'tree',
        filterMultiple: false,
        onFilter: (value, record) => !!record['备注'],
    },
    // @tmpmdel
    // {
    //     title: '非陆籍填1',
    //     dataIndex: '非陆籍填1',
    //     en_title: 'if Foreign set 1',
    //     ch_title: '非陆籍填1',
    //     valueType: 'select',
    //     valueEnum: {
    //         '1': {
    //             text: '1',
    //         },
    //         // 非陆籍
    //         '': {
    //             text: ' ',
    //         },
    //     },
    // },
    // {
    //     title: '法人填1，自然人不填',
    //     dataIndex: '法人填1，自然人不填',
    //     en_title: 'if Legal person set 1',
    //     ch_title: '法人填1，自然人不填',
    //     valueType: 'select',
    //     valueEnum: {
    //         '1': {
    //             text: '1',
    //         },
    //         '': {
    //             text: ' ',
    //         },
    //     },
    // },
    {
        title: '志工编号',
        en_title: 'Commissioner Number',
        ch_title: '志工编号',
        dataIndex: '志工编号',
        render: (text, record) => {
            let valid = record.volunteerNoValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='必填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '-'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '志工编号必填' },
                ],
            };
        }
    },
    {
        title: '志工姓名',
        ch_title: '志工姓名',
        en_title: 'Commissioner Name',
        dataIndex: '志工姓名',
    },
    {
        title: '志工英文名',
        ch_title: '志工英文名',
        en_title: 'Commissioner enName',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '手机号',
        en_title: 'Phone#',
        ch_title: '手机号',
        dataIndex: '手机号',
        render: (text, record, index) => {
            let valid = record.phoneValid;
            // Tooltip
            return !valid ? (
                <Tooltip title='手机号,1开头的11位数字,或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^1\d{10}$/, message: '手机号,1开头的11位数字,或不填' }
                ],
            };
        }
    },
    {
        title: '地址',
        en_title: 'Address',
        ch_title: '地址',
        dataIndex: '地址',
    },
    {
        title: '邮箱',
        dataIndex: '邮箱',
        en_title: 'Email',
        ch_title: '邮箱',
        filters: [
            {
                text: '不含@qq.com',
                value: '@qq.com',
            },
        ],
        filterMode: 'tree',
        filterMultiple: false,
        onFilter: (value, record) => !record['Email'].includes(value),

        render: (text, record) => {
            let valid = record.emailValid;
            // Tooltip
            return !valid ? (
                <Tooltip title='Email须符合邮箱格式或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, message: 'Email须符合邮箱格式或不填' }
                ],
            };
        }
    },
];


export const prev_validColumn = {
    title: '校验',
    en_title: 'Verification',
    ch_title: '校验',
    dataIndex: 'valid',
    width: '100px',
    render: (text, record, index) => {
        //整行的验证状态
        return !record.rcdValid ? <font color='red'>异常</font> : '正常';
    },
    filters: [
        {
            text: '正常',
            value: true,
        },
        {
            text: '异常',
            value: false,
        },
    ],
    filterMode: 'tree',
    onFilter: (value, record) => record['rcdValid'] == value,

    // 1.也可以在col的render控制 
    onCell: (record, rowIndex) => { // 传入两个形参，分别为行内容record与行index
        if (record['cssType']) { // 可根据参数内容进行判断，如果是偶数行，就将背景颜色设置为红色
            return {
                style: {
                    color: 'red', //此处需注意
                },
            };
        }
    },
    editable: false,
};

